import Icon from '../../../components/AppIcon';

interface CustomerInfoSectionProps {
  customerName: string;
  customerDetails: {
    company: string;
    email: string;
    phone: string;
    address: string;
  };
}

const CustomerInfoSection = ({ customerName, customerDetails }: CustomerInfoSectionProps) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-primary/10 rounded-lg">
          <Icon name="User" size={20} className="text-primary" />
        </div>
        <h2 className="text-lg font-semibold text-text-primary">Customer Information</h2>
      </div>

      <div className="space-y-4">
        {/* Company Name Section */}
        <div className="border-b border-border pb-3">
          <div className="flex items-start gap-3">
            <Icon name="Building2" size={16} className="text-text-secondary mt-1 flex-shrink-0" />
            <div className="flex-1">
              <div className="text-sm font-medium text-text-secondary mb-1">Company Name</div>
              <div className="font-semibold text-text-primary">
                {customerDetails?.company || customerName || 'N/A'}
              </div>
            </div>
          </div>
        </div>

        {/* Company Contact Section */}
        <div className="border-b border-border pb-3">
          <div className="flex items-start gap-3">
            <Icon name="User" size={16} className="text-text-secondary mt-1 flex-shrink-0" />
            <div className="flex-1">
              <div className="text-sm font-medium text-text-secondary mb-1">Company Contact</div>
              <div className="font-semibold text-text-primary mb-2">
                {customerName || 'N/A'}
              </div>
              
              {/* Contact Details */}
              <div className="space-y-2 mt-3">
                {customerDetails?.email && (
                  <div className="flex items-center gap-2 text-sm">
                    <Icon name="Mail" size={14} className="text-text-secondary flex-shrink-0" />
                    <span className="text-text-primary">{customerDetails.email}</span>
                  </div>
                )}

                {customerDetails?.phone && (
                  <div className="flex items-center gap-2 text-sm">
                    <Icon name="Phone" size={14} className="text-text-secondary flex-shrink-0" />
                    <span className="text-text-primary">{customerDetails.phone}</span>
                  </div>
                )}

                {customerDetails?.address && (
                  <div className="flex items-start gap-2 text-sm">
                    <Icon name="MapPin" size={14} className="text-text-secondary mt-0.5 flex-shrink-0" />
                    <span className="text-text-primary whitespace-pre-line">{customerDetails.address}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerInfoSection;